import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  OnInit,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  notify,
  SiaSessionParam,
  SiaTokenUser,
  SiaTranslatePipe,
} from '@sia/shared';
import { AuthComponent } from '../../auth.component';

@Component({
  selector: 'two-factor-auth',
  standalone: true,
  imports: [
    MatButton,
    CommonModule,
    FormsModule,
    SiaTranslatePipe,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './two-factor-auth.component.html',
  styleUrl: './two-factor-auth.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TwoFactorAuthComponent extends AuthComponent implements OnInit {
  showQrCode = input(false);
  email = input('');
  request = input('enable');

  #showQrCodeGenerated = signal(false);
  showQrCodeSig = computed(
    () => this.showQrCode() || this.#showQrCodeGenerated(),
  );

  userData = signal<SiaTokenUser>({});
  qrCodeString = signal('');
  type2fa = signal('');
  startValidation = signal(false);
  uri = signal('');

  emailSig = computed(() => this.email() || this.userData()?.email || '');

  async validateTotp() {
    if (this.isOtpInvalid()) {
      notify('Pin errato', 2000, 'error');
      return;
    }

    try {
      const result: any = await this.authService.validateTotp(this.otp());
      if (result) {
        notify(
          'Pin corretto autenticazione abilitata con successo',
          1000,
          'success',
        );
        let params: SiaSessionParam[] = [
          {
            id: 'id',
            value: '' + this.usersService.getUserData()?.id,
          },
          {
            id: 'enable2fa',
            value: true,
          },
        ];
        this.routerService.navigateMenuWithParams(
          'popup^crud-user-profile',
          params,
        );
      }
    } catch (e: any) {}
  }

  async ngOnInit() {
    super.ngOnInit();
    this.userData.set(this.usersService.getUserData()!);
  }

  async startGenerationQrCode(type: string) {
    this.type2fa.set(type);
    this.startCountDown(180);

    let credential: any = {};
    if (!this.userData()) {
      credential.userIdentifier = this.emailSig();
    } else {
      credential.userIdentifier = this.userData().email;
    }

    try {
      const result: any = await this.authService.generateTotpQrCode(type);
      if (result.success) {
        this.startValidation.set(true);
        if (result.qrCode) {
          this.uri.set(result.uri);
          notify('Generazione qrcode avvenuta con successo', 1000, 'success');
          this.qrCodeString.set(result.qrCode);
          this.#showQrCodeGenerated.set(true);
        }
      } else {
        notify('Errore nella generazione del QRcode', 2000, 'error');
      }
    } catch (e: any) {}
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.userData.set({});
    this.otp.set('');
    this.qrCodeString.set('');
    this.type2fa.set('');
    this.startValidation.set(false);
    this.resetCountdown();
    this.uri.set('');
    this.#showQrCodeGenerated.set(false);
  }
}
